import { z } from 'zod';
/**
 * Public store shapes (surface C). The catalog DTO the browser receives.
 * INTERNAL fields (cost_cents, commissioning_cents) are never part of this
 * shape. The backend builds it through an allowlist mapper, field by field,
 * so an internal field can never leak into a response.
 */
export const StoreProductTierSchema = z.enum([
    'home',
    'commercial_ac',
    'dc',
    'high_power',
    'accessory',
    // Warren, 21 October 2026: the Site connectivity category (lib/siteConnectivity.ts).
    'site_connectivity',
]);
export const StoreCheckoutFlowSchema = z.enum(['buy_now', 'quote']);
export const StoreSurfaceSchema = z.enum(['in_app', 'public']);
export const StoreProductSpecsSchema = z.object({
    amperage: z.number().optional(),
    connector_type: z.string().optional(),
    power_kw: z.number().optional(),
    ports: z.number().optional(),
    mount: z.string().optional(),
});
/**
 * Public catalog product. price_cents is the public MSRP in cents (money
 * stays in cents end to end). `id` is the product _id serialized; the catalog
 * card, the /store/product/:id route, and the cart's product_id reference all
 * key off it. cost_cents and commissioning_cents are deliberately absent.
 */
export const StorePublicProductSchema = z.object({
    id: z.string(),
    part_number: z.string(),
    name: z.string(),
    description: z.string().optional(),
    tier: StoreProductTierSchema,
    checkout_flow: StoreCheckoutFlowSchema,
    price_cents: z.number().int().nonnegative(),
    surfaces: z.array(StoreSurfaceSchema),
    is_active: z.boolean(),
    lead_time_label: z.string().optional(),
    specs: StoreProductSpecsSchema.optional(),
    /** Marks the recommended variant in a family. Drives the options-sheet
     *  "Recommended" pill and pins the variant first (recommended-first, then
     *  price). Absent on non-recommended products. */
    recommended: z.boolean().optional(),
});
//# sourceMappingURL=store.js.map